"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Flags = require("country-flag-icons/react/1x1");
const material_1 = require("@mui/material");
const react_1 = require("react");
const CountrySelector_styles_1 = require("../../components/CountrySelector/CountrySelector.styles");
const Divider_1 = require("../../components/Divider");
const Typography_1 = require("../../components/Typography");
const icons_material_1 = require("@mui/icons-material");
const Container_1 = require("../../components/Container");
const theme_1 = require("../../theme");
const Drawer_1 = require("../Drawer");
const CountryItem = ({ country, onClick }) => {
    const Flag = Flags[country.iso2.toUpperCase()];
    return ((0, jsx_runtime_1.jsxs)(material_1.MenuItem, { sx: { padding: '1rem 1.5rem', gap: '16px' }, onClick: (e) => onClick(country, e), value: country.iso2, tabIndex: 0, children: [(0, jsx_runtime_1.jsx)(Flag, { style: { width: '24px', height: '24px', borderRadius: '61px' } }), (0, jsx_runtime_1.jsxs)(Typography_1.default, { typo: "body_sm", children: [country.name, " (+", country.dialCode, ")"] })] }, country.dialCode));
};
const CountrySelector = ({ drawerTitle, onChange, defaultCountry, countries, selectedCountry, searchHandler, disableDropdown, searchInputPlaceHolder, }) => {
    const [isCountrySelectorOpen, setIsCountrySelectorOpen] = (0, react_1.useState)(false);
    const [selected, setSelected] = (0, react_1.useState)();
    const { searchInputStyle, Container } = (0, CountrySelector_styles_1.useCountrySelectorStyles)();
    (0, react_1.useEffect)(() => {
        setSelected(selectedCountry);
    }, [selectedCountry]);
    const onOpen = () => {
        if (disableDropdown)
            return;
        setIsCountrySelectorOpen(true);
    };
    const onClose = () => {
        setIsCountrySelectorOpen(false);
    };
    const countryChangeHandler = (country, event) => {
        onChange(country, event);
        onClose();
        setSelected(country);
    };
    const SelectedFlag = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (countries.length === 0 || !countries)
            return Flags[defaultCountry === null || defaultCountry === void 0 ? void 0 : defaultCountry.toUpperCase()];
        if (selected) {
            return Flags[(_a = selected === null || selected === void 0 ? void 0 : selected.iso2) === null || _a === void 0 ? void 0 : _a.toUpperCase()];
        }
        const defaultCountryCode = (_b = countries === null || countries === void 0 ? void 0 : countries.find((country) => (country === null || country === void 0 ? void 0 : country.iso2) === defaultCountry)) === null || _b === void 0 ? void 0 : _b.iso2;
        return Flags[(defaultCountryCode === null || defaultCountryCode === void 0 ? void 0 : defaultCountryCode.toUpperCase()) || 'TR'] || Flags.TR;
    }, [selected, countries.length, defaultCountry]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { onClick: onOpen, sx: Container, children: [(0, jsx_runtime_1.jsx)(SelectedFlag, { style: { width: '18px', height: '18px', borderRadius: '61px' } }), (0, jsx_runtime_1.jsx)(icons_material_1.ChevronLeft, { sx: {
                            rotate: isCountrySelectorOpen ? '90deg' : '-90deg',
                            transition: 'rotate 0.3s ease-in-out',
                            width: '20px',
                            height: '20px',
                            color: theme_1.theme.qlub.palette.onSurfaceColors.mediumEmphasis,
                        } })] }), (0, jsx_runtime_1.jsxs)(Drawer_1.SwipeableCustomerDrawer, { headerTitle: drawerTitle, open: isCountrySelectorOpen, sx: {
                    marginTop: 0,
                    paddingInline: 0,
                    borderRadius: 0,
                }, onOpen: onOpen, onClose: onClose, hasOverflow: true, contentStyle: {
                    padding: 0,
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { padding: "12px 24px 16px 24px", children: (0, jsx_runtime_1.jsx)(material_1.TextField, { sx: searchInputStyle, classes: {
                                root: 'inputRoot',
                            }, fullWidth: true, InputProps: { startAdornment: (0, jsx_runtime_1.jsx)(icons_material_1.Search, {}) }, placeholder: searchInputPlaceHolder, onChange: searchHandler }) }), (0, jsx_runtime_1.jsx)(Container_1.CustomerContainer, { sx: {
                            height: '164px',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                            overflowY: 'scroll',
                        }, children: countries.map((country, idx) => {
                            country.name = country.localName || country.name;
                            return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CountryItem, { country: country, onClick: countryChangeHandler }, idx), (0, jsx_runtime_1.jsx)(Divider_1.default, {})] }, idx));
                        }) })] })] }));
};
exports.default = CountrySelector;
